import {
  CATEGORY_KPI_TIPS_I18N,
  KEY_GAMES_TABLE_TIPS_I18N,
  TOP_PUBLISHERS_KPI_TIPS_I18N,
  TOP_PUBLISHERS_TABLE_TIPS_I18N,
} from '@home/pages/studio/casualHub/CasualCompetitors/constants';

import type { IStudioInfo } from '@home/pages/studio/type';

const CASUAL_STUDIO_CODE = 'casual';
export const BRIDGE_STUDIO_INFO: IStudioInfo = {
  data: {
    studio_info: {
      studio_code: CASUAL_STUDIO_CODE,
      name_cn: '休闲专区',
      name_en: 'Casual Hub',
      title_cn: '全面洞察IEGG所有休闲游戏与市场表现。',
      title_en: "Insights into IEGG's casual games and competitors",
      company_id: '-',
      icon_url: 'https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1774334785580_休闲游戏专区头像.png',
      background_url:
        'https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1776654771127_企业微信截图_10030cc5-4d17-45bb-a338-4be80550a68a.png',
      studio_background_url:
        'https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1774336939366_casual-company-bacgound.png',
      element_url: 'https://ogdb-cdn.intlgame.cn/aupload/admin/studio_hub/image/1774341216186_casual人物.png',
      sort: 1,
      status: 1,
      description: '',
      focus_genre: '',
    },
    haveHome: false,
    has_studio_editor: false,
    studio_dashboard_list: [
      {
        u_id: '1796155b-2890-11ef-8c05-d0c65bae985d',
        u_parent_id: '0',
        menu_type: '2',
        menu_id: '',
        business_type: 'studio',
        name_en: 'IEGG Casual Overview',
        name_cn: 'IEGG Casual Overview',
        workbook_url: '',
        icon: 'cbt-icon',
        sort: '1',
        url: '',
        path: '/home',
        page_type: 'path',
        urls: '',
        level: 'Home',
        onclick: '',
        is_visit: true,
        new_flag: false,
        dashboard_uuid: '',
        dashboard_custom_id: '',
        tableau_server: '',
        tableau_username: '',
        tableau_site: '',
        preset_id: '',
        workspace_id: '',
        workspace_region: '',
        team_id: '',
        extra_info: '',
        attributes: '',
        looker_models: '',
        dashoboard_list: null,
      },
      {
        u_id: '2796155b-2890-11ef-8c05-d0c65bae985d',
        u_parent_id: '0',
        menu_type: '2',
        menu_id: '',
        business_type: 'studio',
        name_en: 'Casual Overview',
        name_cn: '休闲游戏概览',
        workbook_url: '',
        icon: 'cbt-icon',
        sort: '2',
        url: '',
        path: '/competitors',
        page_type: 'path',
        urls: '',
        level: 'Competitors',
        onclick: '',
        is_visit: true,
        new_flag: false,
        dashboard_uuid: '',
        dashboard_custom_id: '',
        tableau_server: '',
        tableau_username: '',
        tableau_site: '',
        preset_id: '',
        workspace_id: '',
        workspace_region: '',
        team_id: '',
        extra_info: '',
        attributes: '',
        looker_models: '',
        dashoboard_list: null,
      },
    ],
    company: {
      name: '',
      img_url: '',
      national_flag: '',
      location_city: '',
      region: '',
      location_country: '',
      continent: '',
      area: '',
      genre: '',
      game_sum: 0,
    },
    game_list: [],
  },
  loading: false,
  errMsg: '',
};

// 品类大盘 KPI 指标解释 i18n key 配置（intelligence 子系统页面）
export const DBI_CATEGORY_KPI_TIPS_I18N: IRecord<string> = {
  ...CATEGORY_KPI_TIPS_I18N,
  monthly_iap: 'dbi_studio_casual_kpi_cumulative_monthly_iap_tips',
  daily_iap: 'dbi_studio_casual_kpi_cumulative_daily_iap_tips',
};

// 重点游戏表格指标解释 i18n key 配置（按粒度区分）（intelligence 子系统页面）
export const DBI_KEY_GAMES_TABLE_TIPS_I18N: IRecord<IRecord<string>> = {
  monthly: {
    ...KEY_GAMES_TABLE_TIPS_I18N.monthly,
    iap_revenue: 'dbi_studio_casual_keygames_monthly_iap_tips',
  },
  daily: {
    ...KEY_GAMES_TABLE_TIPS_I18N.daily,
    iap_revenue: 'dbi_studio_casual_keygames_daily_iap_tips',
  },
};

// 头部厂商 KPI 指标解释 i18n key 配置（按粒度区分）（intelligence 子系统页面）
export const DBI_TOP_PUBLISHERS_KPI_TIPS_I18N: IRecord<{
  dau: string;
  iap: string;
  download: string;
}> = {
  monthly: {
    ...TOP_PUBLISHERS_KPI_TIPS_I18N.monthly,
    iap: 'dbi_studio_casual_publisher_kpi_monthly_iap_tips',
  },
  daily: {
    ...TOP_PUBLISHERS_KPI_TIPS_I18N.daily,
    iap: 'dbi_studio_casual_publisher_kpi_daily_iap_tips',
  },
};

// 头部厂商表格指标解释 i18n key 配置（按粒度区分）（intelligence 子系统页面）
export const DBI_TOP_PUBLISHERS_TABLE_TIPS_I18N: IRecord<IRecord<string>> = {
  monthly: {
    ...TOP_PUBLISHERS_TABLE_TIPS_I18N.monthly,
    iap_revenue: 'dbi_studio_casual_publisher_table_monthly_iap_tips',
  },
  daily: {
    ...TOP_PUBLISHERS_TABLE_TIPS_I18N.daily,
    iap_revenue: 'dbi_studio_casual_publisher_table_daily_iap_tips',
  },
};
